import React from 'react'
import { connect } from 'react-redux';
import Wix from 'Wix';
import _ from 'lodash'

import {
    GetSlide,
    SlideContainer
} from './style'
import TextCaption from './Captions/TextCaption';
import ButtonCaption from './Captions/ButtonCaption';
import BoxCaption from './Captions/BoxCaption';
import ShapeCaption from './Captions/ShapeCaption';
import { ResponciveModule } from '../../../Utils/responsiveModule';
import { convertCaptionToMobile, getBackgroundGradient } from '../../../Utils/utils';
import ImageCaption from './Captions/ImageCaption';


class Slide extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            captions: [],
            parallaxPosition: 0,
        }
    }

    componentWillMount() {
        let captions = _.cloneDeep(this.props.slide.captions)
        const isMobile = Wix.Utils.getDeviceType() === 'mobile'
        // если капча не была настроена в мобильном редакторе, то подстраваем её тут
        if (isMobile && this.props.slide.editedWidth && !this.props.slide.slideJustTranspiled) {
            // const diffW = this.props.slide.editedWidthMobile / this.props.slide.editedWidth;
            // const diffH = this.props.slide.editedHeightMobile / this.props.slide.editedHeight;

            // передаём сначала размеры мобильного вида (под который надо подстроить)
            // потом десктопного вида (на котором уже настроены капчи)
            // console.log('responsive module activate 1')
            // const mobileConverter = new ResponciveModule(
            //     this.props.slide.editedWidthMobile,
            //     this.props.slide.editedHeightMobile,
            //     this.props.slide.editedWidth,
            //     this.props.slide.editedHeight,
            // );
            // captions.map((caption, i, captionsArray) => {
            // if (caption.needMobileConvert === true) {
            //     caption = mobileConverter.convertCaptionToMobile(caption, captionsArray)
            // } else {
            //     caption = mobileConverter.convertCaptionToMobileAbsentFields(caption, captionsArray)
            // }
            // })
        }
        if (this.props.slide.editedWidth && !this.props.slide.slideJustTranspiled) {
            // когда запускаем слайдер в демо режиме в темплейтах, то размеры окна нужны уже заданные
            const windowInnerWidth = this.props.windowInnerWidthImportant || window.innerWidth
            const windowInnerHeight = this.props.windowInnerHeightImportant || this.props.height

            // console.log('responsive module activate 2', Wix.Utils.getDeviceType() === 'mobile')
            // console.log(window.innerWidth, window.innerHeight)
            const rm = new ResponciveModule(
                //desktop
                windowInnerWidth,
                windowInnerHeight,

                this.props.slide.editedWidth,
                this.props.slide.editedHeight,

                //mobile
                window.innerWidth,
                window.innerHeight,
                this.props.slide.editedWidthMobile,
                this.props.slide.editedHeightMobile,
                Wix.Utils.getDeviceType() === 'mobile'
            );


            captions = rm.adaptCaptions(captions);
            if (Wix.Utils.getDeviceType() === 'mobile') {
                //responsive module for mobile from desktop
                const rmForMobile = new ResponciveModule(
                    window.innerWidth,
                    window.innerHeight,
                    this.props.slide.editedWidth,
                    this.props.slide.editedHeight,
                )
                // captions = rmForMobile.convertSlideCaptionsToMobile(captions).captions
                captions.map((caption, index, captionsArray) => {
                    if (caption.needMobileConvert) {
                        if (caption.version >= 2) {
                            caption.needMobileConvertOnlyPosition = true
                        }
                        caption = rmForMobile.convertCaptionToMobile(caption, captionsArray, 1)
                        delete caption.needMobileConvertOnlyPosition
                        delete caption.needMobileConvert
                    }
                })
            }
            // console.log('responsive module active', captions)
            // console.log('captions', captions)
            // captions = rm.adaptCaptions(_.cloneDeep(this.props.slide.captions));
        }
        // если слайд ещё не редактировался после конвертации настроек со старой версии
        // то адаптация капч происходит по старым правилам
        if (this.props.slide.slideJustTranspiled) {
            console.log('OLD VERSION ADAPTIVE')
        }

        this.setState({
            captions: captions
        })

    }

    componentDidMount() {
        if (this.props.slideIndex === 0) {
        }
    }

    getBoxPosition(box, boxZone) {
        boxZone = {
            x: boxZone.x + box.position.x,
            y: boxZone.y + box.position.y,
        }
        if (box.boxId != '') {
            const outerBoxIndex = _.findIndex(this.props.slide.captions, { id: box.boxId })
            let outerBox = this.props.slide.captions[outerBoxIndex]
            return this.getBoxPosition(outerBox, boxZone)
        } else {
            return boxZone
        }
    }

    getMobileBoxPosition(box, boxZone) {
        boxZone = {
            x: boxZone.x + box.mobilePosition.x,
            y: boxZone.y + box.mobilePosition.y,
        }
        if (box.boxId != '') {
            const outerBoxIndex = _.findIndex(this.props.slide.captions, { id: box.boxId })
            let outerBox = this.props.slide.captions[outerBoxIndex]
            return this.getBoxPosition(outerBox, boxZone)
        } else {
            return boxZone
        }
    }


    render() {
        // const background =
        //     // this.props.settingsReducer.hasParallax ?`transparent` : 
        //     this.props.slide.backgroundColor
        const backgroundColor = {
            type: this.props.slide.backgroundType || 'color',
            colorValue: this.props.slide.backgroundColor,
            gradientLayers: this.props.slide.backgroundGradient || []
        }
        const hasShadow = this.props.slide.hasBackgroundShadow
        const containerStyle = { height: this.props.heigh }
        const deviceType = Wix.Utils.getDeviceType()
        const backgroundShadow = `${this.props.slide.backgroundShadow.x}px ${this.props.slide.backgroundShadow.y}px ${this.props.slide.backgroundShadow.blur}px ${this.props.slide.backgroundShadow.size}px ${this.props.slide.backgroundShadow.color}`
        const slideStyles = {
            boxShadow: hasShadow ? backgroundShadow : null,
            height: `${this.props.height}px`,
            background: getBackgroundGradient({ backgroundColor }),
            backgroundRepeat: 'no-repeat'
        }
        return (
            <SlideContainer className={`slide-container-${this.props.slideIndex}`} style={containerStyle}>
                <div
                    className={`slide-${this.props.slideIndex}`}
                    style={slideStyles}
                >
                    {this.state.captions.map((caption, index) => {
                        if (caption.boxId === '' || caption.boxId === undefined) {
                            switch (caption.type) {
                                case 'button':
                                    return (
                                        <ButtonCaption
                                            caption={caption}
                                            key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex}
                                            captionIndex={index}
                                            animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                            slide={this.props.slide}
                                        />
                                    )
                                    break;

                                case 'box':
                                    return (
                                        <BoxCaption
                                            box={caption}
                                            captions={this.state.captions}
                                            key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex}
                                            captionIndex={index}
                                            animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                            slide={this.props.slide}
                                        />
                                    )
                                    break;

                                case 'shape':
                                    return (
                                        <ShapeCaption
                                            caption={caption}
                                            key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex}
                                            captionIndex={index}
                                            animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            slide={this.props.slide}
                                        />
                                    )
                                    break;

                                case 'image':
                                    return (
                                        <ImageCaption
                                            caption={caption}
                                            key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex}
                                            captionIndex={index}
                                            animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            slide={this.props.slide}
                                        />
                                    )

                                default:
                                    return (
                                        <TextCaption
                                            caption={caption}
                                            key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex}
                                            captionIndex={index}
                                            animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                            slideJustTranspiled={this.props.slide.slideJustTranspiled}
                                            lang={this.props.lang}
                                            locale={this.props.locale}
                                            slide={this.props.slide}
                                        />
                                    )
                                    break;
                            }
                        }
                    })}
                </div>


                {/* <GetSlide className={`slide-${this.props.slideIndex}`}
                    backgroundColor={backgroundColor}
                    parallaxPosition={this.state.parallaxPosition}
                    hasShadow={hasShadow}
                    backgroundShadow={`${this.props.slide.backgroundShadow.x}px ${this.props.slide.backgroundShadow.y}px ${this.props.slide.backgroundShadow.blur}px ${this.props.slide.backgroundShadow.size}px ${this.props.slide.backgroundShadow.color}`}
                    height={this.props.height}>
                    {this.state.captions.map((caption, index) => {
                        if ((caption.boxId === '' || caption.boxId === undefined) && (deviceType === 'desktop' || caption.mobileShow)) {
                            switch (caption.type) {
                                case 'button':
                                    return (
                                        <ButtonCaption caption={caption} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index} animationIn={caption.animationIn}
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;

                                case 'box':
                                    return (
                                        <BoxCaption box={caption} captions={this.state.captions} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index} animationIn={caption.animationIn} 
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;

                                case 'shape':
                                    return (
                                        <ShapeCaption caption={caption} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index} animationIn={caption.animationIn} 
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;

                                default:
                                    return (
                                        <TextCaption caption={caption} key={`caption-${index}`}
                                            slideIndex={this.props.slideIndex} captionIndex={index} animationIn={caption.animationIn} 
                                            widgetDimensions={this.props.widgetDimensions}
                                            unicalClassName={this.props.unicalClassName}
                                        />
                                    )
                                    break;
                            }
                        }
                    })}
                </GetSlide> */}


            </SlideContainer>
        )
    }
}

// function mapStateToProps(state) {
//     return state
// }

// export default connect(mapStateToProps)(Slide);
export default Slide;